var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
var client = axios.create({
    baseURL: SERVICE_URL + "/api/"
});
export function initGeosegmentationHtmlElProps(refEl, fields) {
    if (!refEl || !fields)
        return;
    refEl.dataset.geosegmentation = fields.geoSegmentation || "";
    refEl.dataset.geosegmentationexception = fields.geoSegmentationException || "";
    refEl.dataset.segmentpersona = fields.segmentPersona || "";
    refEl.dataset.segmentpersonaexception = fields.segmentPersonaException || "";
    refEl.dataset.dynamicshowcondition = fields.dynamicShowCondition || "";
    var hasGeoSegmentationResult = hasGeoSegmentation(fields);
    if (hasGeoSegmentationResult) {
        refEl.style.display = "none";
    }
    return hasGeoSegmentationResult;
}
export function hasGeoSegmentation(fields) {
    if (!fields)
        return false;
    return !!fields.geoSegmentation || !!fields.geoSegmentationException || !!fields.segmentPersona || !!fields.segmentPersonaException || !!fields.dynamicShowCondition;
}
export function checkShowGeoSegmentationStrips() {
    return __awaiter(this, void 0, void 0, function () {
        var userregion, segmentuserid, geoCookiePromise, segmentCookiePromise, values, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    userregion = null;
                    segmentuserid = null;
                    geoCookiePromise = new Promise(function (resolve, reject) {
                        waitForCookie("_nvk_g", 0, 3500, resolve, reject);
                    });
                    segmentCookiePromise = new Promise(function (resolve, reject) {
                        waitForCookie("ajs_anonymous_id", 0, 3500, resolve, reject);
                    });
                    return [4 /*yield*/, Promise.all([geoCookiePromise, segmentCookiePromise])];
                case 1:
                    values = _a.sent();
                    if (!values)
                        return [2 /*return*/];
                    console.log("segmentation cookie promises resolved (_nvk_g, ajs_anonymous_id): ", values);
                    userregion = values[0];
                    segmentuserid = values[1];
                    document.querySelectorAll('[data-geosegmentation],[data-geosegmentationexception],[data-dynamicshowcondition]').forEach(function (element) {
                        var strip = element;
                        var geoSegmentation = strip.dataset.geosegmentation;
                        var geoSegmentationException = strip.dataset.geosegmentationexception;
                        var segmentPersona = strip.dataset.segmentpersona;
                        var segmentPersonaException = strip.dataset.segmentpersonaexception;
                        var dynamicShowCondition = strip.dataset.dynamicshowcondition;
                        if (geoSegmentation || geoSegmentationException || segmentPersona || segmentPersonaException || dynamicShowCondition) {
                            var dynamicShowConditionResult = false;
                            var hasDynamicShowCondition = !!dynamicShowCondition;
                            if (hasDynamicShowCondition) {
                                try {
                                    dynamicShowConditionResult = eval(dynamicShowCondition);
                                }
                                catch (e) {
                                    dynamicShowConditionResult = false;
                                    console.log("checkDynamicShowStrips", e);
                                }
                            }
                            checkSegmentation(userregion, strip, geoSegmentation, geoSegmentationException, segmentuserid, segmentPersona, segmentPersonaException, hasDynamicShowCondition, dynamicShowConditionResult);
                        }
                    });
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    console.warn("Geosegmentation fail: ", e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
function checkSegmentation(userregion, strip, geoSegmentation, geoSegmentationException, segmentuserid, segmentPersona, segmentPersonaException, hasDynamicShowCondition, dynamicevalresult) {
    return __awaiter(this, void 0, void 0, function () {
        var request, result, data, targetEl;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        'userregion': userregion,
                        'geosegmentation': geoSegmentation,
                        'geosegmentationexception': geoSegmentationException,
                        'segmentuserid': segmentuserid,
                        'segmentpersona': segmentPersona,
                        'segmentpersonaexception': segmentPersonaException,
                        'hasdynamicshowcondition': hasDynamicShowCondition,
                        'dynamicevalresult': dynamicevalresult
                    };
                    return [4 /*yield*/, client.post("geosegmentationchecker", request)];
                case 1:
                    result = _a.sent();
                    data = result && result.data;
                    console.log("geosegmentationchecker", data);
                    console.log("show strip", strip.classList.contains('geo-notinit'), strip.classList.contains("modal"));
                    if (data.show) {
                        strip.style.display = '';
                        strip.classList.remove('geo-notinit');
                        if (strip.dataset.triggerclicktargetaftergeoinit) {
                            targetEl = strip.dataset.triggerclicktargetaftergeoinit[0] == "#" ?
                                document.getElementById(strip.dataset.triggerclicktargetaftergeoinit) :
                                document.querySelector(strip.dataset.triggerclicktargetaftergeoinit);
                            targetEl && targetEl.click();
                        }
                    }
                    else if (strip.classList.contains("explorer-card-container")) {
                        strip.remove();
                        setTimeout(function () {
                            window.dispatchEvent(new Event('resize'));
                        }, 0);
                    }
                    else if (strip.classList.contains("modal")) {
                        strip.classList.remove("geo-notinit");
                        strip.classList.add("geo-notshow");
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function waitForCookie(cookieName, currentTimeout, maxTimeout, resolve, reject) {
    var myCookie = getCookie(cookieName);
    if (myCookie) {
        resolve(myCookie);
        return;
    }
    if (currentTimeout > maxTimeout) {
        resolve("");
        return;
    }
    currentTimeout += 500;
    setTimeout(waitForCookie.bind(this, cookieName, currentTimeout, maxTimeout, resolve, reject), 500);
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
